import axios from 'axios';
import { baseUrlDev, urlApiAsesoria } from '../Config/baseUrl';
import { IRegistrarVideo } from '../Interfaces/IProductos';

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const getProductos = (data: any) => {
  return axios.post(urlApiAsesoria + 'retoAsesoria/productos', data, config);
};

export const registrarVideo = (data: IRegistrarVideo) => {
  return axios.post(urlApiAsesoria + 'retoAsesoria/registrarVideo', data, config);
};
